// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GgFfO","newExpiryDate":"styles_newExpiryDate__YXaB4","footer":"styles_footer__14-Nt"};